import { merge } from 'lodash';

const TypeMapping = {
    'String': '',
    'Number': null,
    'Boolean': false
};

const schemaToObject = schema => {
    let o = {};

    if (Array.isArray(schema)) {
        return [];
    } else if (typeof schema === 'object') {
        if (schema.fields) {
            return schemaToObject(schema.fields);
        } else if (schema.type) {
            return TypeMapping[schema.type];
        }

        for (var key in schema) {
            let child = schemaToObject(schema[key]);
            if (schema[key].fields) {
                o = merge(o, child);
            } else {
                o[key] = child;
            }
        }
    }

    return o;
}

const schemaToMongo = schema => {
    let mongoSchema = Array.isArray(schema) ? [] : {};

    if (typeof schema !== 'object' && typeof schema !== 'array')
        return schema;

    // Ignore the current schema object if it is a container/group for fields
    if (!schema.type && schema.fields) {
        return schemaToMongo(schema.fields);
    }

    for (var key in schema) {
        let childSchema = schemaToMongo(schema[key]);
        if (schema[key].fields && !schema[key].type) {
            mongoSchema = merge(mongoSchema, childSchema);
        } else {
            mongoSchema[key] = childSchema;
        }
    }

    return mongoSchema;
}

const schemaWhere = (o, key) => {
    let resultPaths = [];

    let searchFor = (o, path=[]) => {
        if (o[key] !== undefined) {
            return resultPaths.push(path);
        }

        if (typeof o === 'object' || Array.isArray(o)) {
            for (var _key in o) {
                searchFor(o[_key], [...path, _key]);
            }
        }
    }

    searchFor(o);

    return resultPaths;
}

const getTranslation = (o, language) => {
  if (typeof o === 'object') {
    o = o[language || window.language];
  }

  return o;
}

const getScui = (schema, key, deflt, mode="view") => {
  let value = schema["ui:" + key];
  if (value !== undefined && value[mode]) return value[mode];
  else if (value !== undefined) return value;
  else return deflt;
}

export {
    schemaToObject,
    schemaToMongo,
    schemaWhere,
    getTranslation,
    getScui
}



// WEBPACK FOOTER //
// ./src/utils/schemaUtil.js